/* eslint-disable jquery/no-val, jquery/no-data */
import $ from 'jquery';

function showJob(job) {
    job.addClass('show-job');
    job.removeClass('hide-job');

    return true;
}

function hideJob(job) {
    job.removeClass('show-job');
    job.addClass('hide-job');

    return true;
}

export async function initJobs() {
    window.filterJobs = () => {
        let company = $('#filter_company').val(),
            location = $('#filter_location').val(),
            jobs = $('#job_pdfs a');

        jobs.each((index) => {
            if (company === 'all' && location === 'all') {
                showJob($(jobs[index]));
            } else if (
                company !== 'all' &&
                location !== 'all' &&
                company === $(jobs[index]).data('company') &&
                location === $(jobs[index]).data('location')
            ) {
                showJob($(jobs[index]));
            } else if (company === 'all' && location === $(jobs[index]).data('location')) {
                showJob($(jobs[index]));
            } else if (location === 'all' && company === $(jobs[index]).data('company')) {
                showJob($(jobs[index]));
            } else {
                hideJob($(jobs[index]));
            }
        });

        if (!jobs.hasClass('show-job')) {
            showJob($('.no-jobs'));
        } else {
            hideJob($('.no-jobs'));
        }

        return true;
    };
}
